import { Button } from "@izicvs/ui";
import { t } from "@lingui/macro";
import { UserSwitch, X } from "@phosphor-icons/react";
import { useNavigate } from "react-router";

import { queryClient } from "@/client/libs/query-client";
import { useImpersonationStore } from "@/client/stores/impersonation";

// Compact indicator shown in the sidebar header while an admin manages a
// member's account, with a quick way back to their own session.
export const ImpersonationBanner = () => {
  const member = useImpersonationStore((state) => state.member);
  const clear = useImpersonationStore((state) => state.clear);
  const navigate = useNavigate();

  if (!member) return null;

  const memberName = member.name;

  const onExit = () => {
    clear();
    // Drop the member's cached data so the admin's own data is fetched fresh.
    queryClient.removeQueries();
    void navigate("/dashboard/organizations");
  };

  return (
    <div className="rounded-lg border border-primary/20 bg-primary/10 p-2.5">
      <div className="flex items-center gap-x-2">
        <UserSwitch className="size-4 shrink-0 text-primary" weight="bold" />
        <p className="min-w-0 flex-1 truncate text-xs font-medium leading-tight">
          {t`You are managing ${memberName}'s account.`}
        </p>
      </div>
      <Button
        size="sm"
        variant="secondary"
        className="mt-2 h-7 w-full gap-1.5 text-xs"
        onClick={onExit}
      >
        <X className="size-3.5" />
        {t`Exit`}
      </Button>
    </div>
  );
};
